import SwalBase from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

const BASE_CUSTOM_CLASS = {
    popup: 'ecx-swal-popup',
    title: 'card-title ecx-swal-title',
    htmlContainer: 'ecx-swal-html',
    confirmButton: 'btn btn-primary btn-sm',
    cancelButton: 'btn btn-secondary btn-sm',
    denyButton: 'btn btn-outline-secondary btn-sm',
    actions: 'gap-3 ecx-swal-actions',
    input: 'form-control form-control-sm ecx-swal-input',
    validationMessage: 'ecx-swal-validation',
};

const Swal = SwalBase.mixin({
    buttonsStyling: false,
    reverseButtons: true,
    focusCancel: true,
    customClass: BASE_CUSTOM_CLASS,
});

export const showSuccess = (title, text, options = {}) =>
    Swal.fire({
        icon: 'success',
        title,
        text,
        timer: 2000,
        showConfirmButton: false,
        ...options,
    });

export const showError = (title, text, options = {}) =>
    Swal.fire({
        icon: 'error',
        title,
        text,
        confirmButtonText: 'OK',
        customClass: {
            confirmButton: 'btn btn-secondary btn-sm',
        },
        ...options,
    });

export const showWarning = (title, text, options = {}) =>
    Swal.fire({
        icon: 'warning',
        title,
        text,
        confirmButtonText: 'OK',
        customClass: {
            confirmButton: 'btn btn-secondary btn-sm',
        },
        ...options,
    });

export const showToast = (title, text, options = {}) =>
    Swal.fire({
        icon: 'success',
        title,
        text,
        toast: true,
        position: 'top-end',
        timer: 1500,
        showConfirmButton: false,
        ...options,
    });

export const confirmDelete = (options = {}) =>
    Swal.fire({
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '<i class="bi bi-check"></i> Yes, delete',
        cancelButtonText: '<i class="bi bi-x"></i> Cancel',
        customClass: {
            confirmButton: 'btn btn-danger btn-sm',
        },
        ...options,
    });

export const confirmAction = (options = {}) =>
    Swal.fire({
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: '<i class="bi bi-check"></i> Confirm',
        cancelButtonText: '<i class="bi bi-x"></i> Cancel',
        ...options,
    });

export default Swal;
